import { useMemo, useState } from 'react';
import { Transfer } from 'antd';
import { observer } from 'mobx-react-lite';

import { TPermission } from '../../core/permissions';

type RolePermissionsTransferProps = {
  permList: TPermission[];
  value?: Pick<TPermission, 'id'>[];
  onChange?: (value: Pick<TPermission, 'id'>[]) => void;
};

export const RolePermissionsTransfer = observer(
  ({ permList, value, onChange }: RolePermissionsTransferProps) => {
    const [selectedKeys, setSelectedKeys] = useState<string[]>([]);

    const targetKeys = useMemo(() => {
      if (!value) return [];

      return value.map(({ id }) => String(id));
    }, [value]);

    const dataSource = useMemo(() => {
      const data = permList.map(({ id, title }) => ({
        id: String(id),
        title,
      }));

      return data;
    }, [permList]);

    const onSelectChange = (
      sourceSelectedKeys: string[],
      targetSelectedKeys: string[],
    ) => {
      setSelectedKeys([...sourceSelectedKeys, ...targetSelectedKeys]);
    };

    const handleChange = (
      nextTargetKeys: string[],
      // direction: TransferDirection,
      // moveKeys: string[],
    ) => {
      const roles = nextTargetKeys.map((id) => ({ id: Number(id) }));

      onChange?.(roles);
    };

    return (
      <Transfer
        rowKey={(row) => row.id}
        dataSource={dataSource}
        listStyle={{ width: '100%', minHeight: 400 }}
        titles={['Все разрешения', 'Разрешения роли']}
        targetKeys={targetKeys}
        selectedKeys={selectedKeys}
        style={{ width: '100%' }}
        onChange={handleChange}
        onSelectChange={onSelectChange}
        render={(item) => item.title}
      />
    );
  },
);
